/**
 * api接口统一管理
 */
import { get, post, remove, put } from "./http";
/**
 *
 * @param {string} params
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */
//admin ------api
export const getADMIN = {
  //登录
  login: params =>
    post("/login", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    })
  //修改
  // set: params => post("/Login/UpdatePassword", params)
};
//cplx ------api
export const getCPLX = {
  //获取table列表
  getTable: params => get("/product", params),
  //添加table列表
  addTable: params =>
    post("/product", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/product", params, id),
  //删除table列表
  delTable: params => remove("/product", params)
};
//mjgl ------api
export const getMJGL = {
  //获取table列表
  getTable: params => get("/roll", params),
  //添加table列表
  addTable: params =>
    post("/roll", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/roll", params, id),
  //删除table列表
  delTable: params => remove("/roll", params)
};
//zbcp ------api
export const getZBCP = {
  //根据id获取
  getPositionId: params => get(`/product_type/${params}`),
  //根据id获取
  getTabelId: params => get(`/warranty/${params}`),
  //获取table列表
  getTable: params => get("/warranty", params),
  //添加table列表
  addTable: params =>
    post("/warranty", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/warranty", params, id),
  //删除table列表
  delTable: params => remove("/warranty", params),
  //售后-审核质保
  initiatePass: params =>
    post("/warranty/pass", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //售后-发起质保
  initiateQuality: params =>
    post("/warranty/initiate", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    })
};
//yys ------api
export const getYYS = {
  //获取table列表
  getTable: params => get("/partner", params),
  //添加table列表
  addTable: params =>
    post("/partner", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/partner", params, id),
  //删除table列表
  delTable: params => remove("/partner", params)
};
//md ------api
export const getMD = {
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    }),
  //获取table列表
  getTable: params => get("/store", params),
  //添加table列表
  addTable: params =>
    post("/store", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/store", params, id),
  //删除table列表
  delTable: params => remove("/store", params)
};
//md ------api
export const getSGAL = {
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    }),
  //获取table列表
  getTable: params => get("/case", params),
  //添加table列表
  addTable: params =>
    post("/case", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/case", params, id),
  //删除table列表
  delTable: params => remove("/case", params)
};
//js ------api
export const getJS = {
  //获取table列表
  getTable: params => get("/mechanic", params),
  //添加table列表
  addTable: params =>
    post("/mechanic", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/mechanic", params, id),
  //删除table列表
  delTable: params => remove("/mechanic", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

//xw ------api
export const getXW = {
  //获取table列表
  getTable: params => get("/news", params),
  //添加table列表
  addTable: params =>
    post("/news", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/news", params, id),
  //删除table列表
  delTable: params => remove("/news", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

//cp ------api
export const getCP = {
  //获取部位列表
  getTable: params => get("/product_type", params),
  //添加部位
  addTable: params =>
    post("/product_type", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑产品部位列表
  editTable: (params, id) => put("/product_type", params, id),
  //删除窗膜table列表
  delTable: params => remove("/product_type", params)
};

export const getCPJM = {
  //获取产品系列
  getWFTable: params => get("/product_model", params),
  //添加产品系列
  addWFTable: params =>
    post("/product_model", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑产品系列
  updateWFTable: (params, id) => put("/product_model", params, id),
  //删除table列表
  delWFTable: params => remove("/product_model", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

export const getBanner = {
  delBanner: params => remove("/banner", params),
  editBanner: (params, id) => put("/banner", params, id),
  //添加banner
  getBanner: params => get("/banner", params),
  //添加banner
  addBanner: params =>
    post("/banner", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

export const carModel = {
  //获取table列表
  getTable: params => get("/car", params),
  //添加table列表
  addTable: params =>
    post("/car", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/car", params, id),
  //删除table列表
  delTable: params => remove("/car", params),
  getTableInfo: params => post("/Car/GetCarInfoById", params)
};

export const carBrand = {
  //获取品牌列表
  getTable: params => get("/car_brand", params),
  //添加table列表
  addTable: params =>
    post("/car_brand", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/car_brand", params, id),
  //删除table列表
  delTable: params => remove("/car_brand", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

export const getOur = {
  //获取品牌列表
  getTable: params => get("/about", params),
  //添加table列表
  addTable: params =>
    post("/about", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/about", params, id),
  //删除table列表
  delTable: params => remove("/about", params),
  //添加table列表
  morenTodo: params =>
    post("/about/active", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};



// WEBPACK FOOTER //
// ./src/axios/api.js